'use client'
import TipSvg from '@/assets/icons/dp-final-price-tip.svg';
import { useTranslation } from '@/i18n/client';
import { Button, Popover } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { useState } from "react";
import styles from "./index.module.scss";
const ConfirmButton = muiStyled(Button)(() => ({
  color: '#fff',
  backgroundColor: '#CC0C1C',
  lineHeight: '28px',
  padding: '0 8px',
  minWidth: 'auto',
  '&:hover': {
    borderColor: '#990915',
    backgroundColor: '#990915',
    boxShadow: 'none',
  },
}));
const WidthArrowPopover = muiStyled(Popover)(({ theme }) => ({
  marginTop: '10px',
  overflow: 'visible',
  '& .MuiPopover-paper': {
    boxShadow: theme.shadows[4],
    overflow: 'visible',
    padding: "16px",
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '-8px', // 调整箭头位置
      left: '50%', // 调整箭头位置
      transform: 'translateX(-50%)',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: `8px solid ${theme.palette.background.paper}`,
      // boxShadow: 'var(--mui-shadows-8)' // 可选阴影
      filter: 'drop-shadow(0px -1px 1px rgba(0,0,0,0.12))',
    },
  },
}));

interface ArrowPopoverProps {
  content: React.ReactNode
}
export default function TipsArrowPopover(props: ArrowPopoverProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const isPopoverOpen = Boolean(anchorEl);
    const { t } = useTranslation();
    const id = isPopoverOpen ? 'simple-popover' : undefined;
    const handlePopoverClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const onConfirm = () => {
    handlePopoverClose();
  }
  return (
    <>
        <TipSvg aria-describedby={id} onClick={handlePopoverClick} />
        <WidthArrowPopover
            id={id}
            open={isPopoverOpen}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            {props.content}
            <div className={styles.tipBottomButton}>
                <ConfirmButton onClick={onConfirm}>{t("common.btnText.ok")}</ConfirmButton>
            </div>
            
        </WidthArrowPopover>
    </>
    
  );
}